import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserStateService} from './user-state.service';
import {WebSocketService} from './web-socket.service';
import {Observable, from} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserAppService {
  constructor(
    private http: HttpClient,
    private userStateService: UserStateService,
    private webSocketService: WebSocketService
  ) {}

  getUserStatus() {
    const url = 'get_user_status';
    return this.http.get(url);
  }

  getUserRoles(){
    const url = 'users_app/user_roles'
    return this.http.get(url);
  }

  getUser() {
    const url = 'users_app/manage_users';
    return this.http.get(url);
  }

  updateUserRole(user: any) {
    const url = `users_app/manage_users/${user?.username}`;
    return this.http.put(url, user);
  }

  addUser(user: any) {
    const url = 'users_app/manage_users';
    return this.http.post(url, user);
  }

  removeUser(user: any) {
    const url = `users_app/manage_users/${user?.username}`;
    return this.http.delete(url);
  }


  getRegistrationAllowedStatus() {
    const url = 'registration_allow_status';
    return this.http.get(url);
  }

  /**
   * @deprecated Use UserStateService.loadUserInfo() instead for better caching
   */
  async loginStatus(): Promise<any> {
    // Delegate to UserStateService for better caching
    return this.userStateService.loadUserInfo();
  }

  registerTenant(tenant: any) {
    const url = 'register';
    return this.http.post(url, tenant);
  }

  verifyEmail(data: any) {
    const url = 'verify_email';
    return this.http.post(url, data);
  }

  generateNewOtp() {
    const url = 'verify_email';
    return this.http.get(url);
  }

  login(credentials: any) {
    const url = 'login';
    return this.http.post(url, credentials);
  }

  logout() {
    const url = 'logout';
    // Clear cached user info on logout
    this.userStateService.clearUserInfo();
    // The socket is bound server-side to the user's group at handshake, and
    // connect() no-ops while one exists. Without this, a second user logging in
    // on the same tab would keep the first user's socket — and their task toasts.
    this.webSocketService.disconnect();
    return this.http.post(url, null);
  }

  getWebChat() {
    const url = `/users_app/webchat`;
    return this.http.get(url);
  }

  getHomepage() {
    const url = '/users_app/custom-homepage';
    return this.http.get(url);
  }
}
